import React, { useContext } from "react";
import { Carousel, Card } from "flowbite-react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";

const Home = () => {
  const { jobs } = useContext(GlobalContext);

  return (
    <>
      <div className="relative">
        <div className="h-64 sm:h-64 xl:h-80 2xl:h-96">
          <Carousel slideInterval={2000}>
            <img
              src="https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Job Search"
              className="w-full h-full object-cover"
            />
            <img
              src="https://images.pexels.com/photos/416405/pexels-photo-416405.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Job Search"
              className="w-full h-full object-cover"
            />
            <img
              src="https://images.pexels.com/photos/8867435/pexels-photo-8867435.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Job Search"
              className="w-full h-full object-cover"
            />
            <img
              src="https://images.pexels.com/photos/3184430/pexels-photo-3184430.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
              alt="Job Search"
              className="w-full h-full object-cover"
            />
          </Carousel>
        </div>
        <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-gray-600 bg-opacity-75">
          <h2 className="text-white text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold mb-4 text-center">
            Find Your Dream Job
          </h2>
        </div>
      </div>

      <section id="job-vacancy-section" className="p-5">
        <div className="container mx-auto grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {jobs.map((job) => (
            <div key={job.id}>
              <Card className="mt-5">
                <img
                  src={job.company_image_url}
                  alt="Job"
                  className="h-40 sm:h-56 object-cover w-full"
                />
                <h5 className="text-xl sm:text-2xl font-bold tracking-tight text-gray-900 dark:text-white truncate">
                  {job.title}
                </h5>
                <p className="text-sm sm:text-base font-normal text-gray-700 dark:text-gray-400 truncate">
                  {job.company_name}
                </p>
                <div className="flex item-center justify-between mt-3">
                  <button className="px-3 py-2 bg-gray-800 text-white text-xs sm:text-sm font-bold uppercase rounded">
                    {job.job_tenure}
                  </button>
                  <button className="px-3 py-2 bg-gray-800 text-white text-xs sm:text-sm font-bold uppercase rounded">
                    {job.company_city}
                  </button>
                </div>
                <Link
                  to={`/about/${job.id}`}
                  className="mt-3 px-3 py-2 bg-blue-500 text-white text-xs sm:text-sm font-bold uppercase rounded"
                >
                  Detail
                </Link>
              </Card>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default Home;
